
export class PCTRegionCodeExtension {
}
